import { get, put, Delete, post } from '../axios'


// 获取协议列表
export const getProtocol = (params) => post('/web/protocols/get', params)

// 获取协议详情
export const viewProtocol = (params) => get('/web/protocols/view/' + params)

// 创建协议
export const createProtocol = (data) => post('/web/protocols/create', data)

// 更新协议
export const updateProtocol = (data) => put('/web/protocols/update', data)

// 删除协议
export const deleteProtocol = (data) => Delete('/web/protocols/delete?ids='+ data)

// 远程搜索协议列表
export const remoteSearchProtocol = (params) => get('/web/protocols/name', params)
// 获取协议地址
export const getProtocolAddress = (params) => get('/web/protocols/address', params)

// 复制协议
export const copyProtocol = (data) => post('/web/protocols/copy', data)
